export const services = {
  title: "Servicios Adicionales",
  subtitle: "Servicios complementarios para facilitar la vida escolar de tu familia",
  transport: {
    title: "Taxi desde Vigo",
    description: "Taxi desde Vigo. Mínimo 4 plazas. Es el único servicio con compromiso de reserva por todo el trimestre; la tarifa indicada es mensual.",
    roundTrip: "Ida y vuelta",
    roundTripPrice: "225€/mes"
  },
  earlyBirds: {
    title: "Early Birds",
    schedule: "Servicio diario a partir de las 8:15h",
    monthly: "Mensual",
    monthlyPrice: "75€",
    daily: "Días sueltos",
    dailyPrice: "7€",
    note: "* Precio por familia - Lunes a Viernes incluidos"
  },
  lunch: {
    title: "Comedor",
    description: "Comida y snack de la mañana siguiendo una dieta equilibrada con productos ecológicos y locales",
    monthly: "5 días/semana",
    monthlyPrice: "195€",
    threeDays: "3 días/semana",
    twoDays: "2 días/semana",
    perMonth: "/mes",
    note: "Los abonos de comedor se reservan y pagan mensualmente. Elige 5, 3 o 2 días fijos a la semana. Incluyen ludoteca hasta las 17:00 (viernes hasta las 16:00). Día suelto: avisar con 48 horas de antelación.",
    daily: "Días sueltos",
    dailyPrice: "15€",
    takeaway: {
      title: "Comida para llevar",
      description: "Por el mismo precio también se puede encargar la comida para recoger en cualquier momento entre las 14:00h y las 17:00h. El tupper lo proporciona Gándara."
    }
  },
  ludoteca: {
    title: "Tardes Gándara",
    schedule: "Horario: 14:00h a 17:00h",
    description: "Comida y ludoteca hasta las 17:00 (viernes, 16:00), con abonos de 5, 3 o 2 días a la semana",
    freeWith: "Ver las extraescolares 26-27: horario, actividades y precios",
    options: [
      { label: "Comedor", price: "14:00 - 15:00" },
      { label: "Ludoteca", price: "15:00 - 17:00 (viernes, 16:00)" }
    ],
    note: "* Información y reservas por WhatsApp: 616 975 363"
  },
  contact: {
    title: "¿Te interesa algún servicio?",
    description: "Contacta con nosotros para conocer más detalles y disponibilidad",
    button: "Reservar una visita"
  }
};
